import { AppLayout } from 'layouts';
import { Channels } from 'features/channels';
import { useGetPathToEntityDetail } from '../../hooks';
import { useNavigateToChannelDetail, useNavigateToOrganizationChannel } from '../hooks';

const PageChannels = () => {
  const navigateToOrganizationChannel = useNavigateToOrganizationChannel();
  const navigateToChannelDetail = useNavigateToChannelDetail();
  const getPathToEntityDetail = useGetPathToEntityDetail();

  return (
    <AppLayout>
      <Channels
        getPathToEntityDetail={getPathToEntityDetail}
        navigateToChannelDetail={navigateToChannelDetail}
        navigateToOrganizationChannel={navigateToOrganizationChannel}
      />
    </AppLayout>
  );
};

export default PageChannels;
